import React from "react";
import { connect } from "react-redux";
import {
  getPersonNamesReason,
} from "../../../actions";
import hoistNonReactStatics from 'hoist-non-react-statics'

let loaded = false;

export const withPersonNamesReason = (WrapperComponent) => {
  class WithPersonNamesReason extends React.Component {
    componentDidMount() {
      const { getPersonNamesReason } = this.props;
      if (loaded) return;
      loaded = true;
      getPersonNamesReason();
    }
    getPersonNamesReasonOptions = () => undefined
    getPersonNamesReasonLocaleOptions = () => {
      const { personNamesReason } = this.props;
      return personNamesReason.map(({ created_at, ...rest }) => ({ ...rest }));
    }
    render() {
      return (
        <WrapperComponent 
          {...this.props} 
          personNamesReasonOptions={this.getPersonNamesReasonOptions()} 
          personNamesReasonLocaleOptions={this.getPersonNamesReasonLocaleOptions()} 
        />
      )
    }
  }
  const mapStateToProps = ({ personNamesReason }) => ({ personNamesReason })
  const WithPersonNamesReasonHOC = connect(mapStateToProps, {
    getPersonNamesReason,
  })(WithPersonNamesReason);
  hoistNonReactStatics(WithPersonNamesReasonHOC, WrapperComponent)
  return WithPersonNamesReasonHOC
}

